module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/icon-dinner-course-3e6259a428d6959bc63345e386dc050c.svg";